export default __webpack_public_path__ + "static/media/playStoreIcon.134f449c.svg";